export default state => state.customer?.requiredDetails !== undefined;
